import { NetworkInterface } from '@signageos/common-types/dist/Device/Network/NetworkInterface';

export const NetworkStatusChanged = 'Network.StatusChanged';
export interface NetworkStatusChanged {
	type: typeof NetworkStatusChanged;
	data: NetworkInterface[];
}
